import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEnableClusteringSelector, toogleClastering } from './mapSlice';

export default function useMapEnableClustering() {
  const dispatch = useDispatch();
  const isEnableClustering = useSelector(isEnableClusteringSelector);

  const toggle = React.useCallback(() => {
    dispatch(toogleClastering());
  }, [dispatch]);

  return {
    isEnableClustering,
    toggle,
  };
}
